import React from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button, Form} from "semantic-ui-react";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../components/Input/TextArea/TextAreaLbl";
import 'semantic-ui-css/semantic.min.css';
import './createUserGroupStyle.scss';
import Cookies from "js-cookie";
import axios from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";

class CreateUserGroupModal extends React.Component {

  state = {
    corporateId: 0,
    corporate_name: "",
    group_name: "",
    group_desc: "",
  };

  componentDidMount() {
    this.props.setUserGroupHandler(null);
    let corporateId = this.props.corporateId;
    let corporateName = this.props.corporateName;
    if(corporateId !== -1 && corporateId !== null && corporateId !== undefined && corporateName !== null && corporateName !== undefined) {
      this.setState({
        corporateId: corporateId,
        corporate_name: corporateName,
      });
    }
  }

  onChangeUserGroupName = event => {
    let value = event.target.value;
    this.setState({
      group_name: value
    });
  };

  onChangeUserGroupDesc = event => {
    let value = event.target.value;
    this.setState({
      group_desc: value
    });
  };

  createUserGroup=()=>{
    this.state.group_name === ""?common.notifyMessage("User group name can't be empty") :
      this.state.group_desc === ""?common.notifyMessage("User group description can't be empty") :
        this.createUserGroup_();
  };

  createUserGroup_=()=>{
    swal({
      title: "Do you want to proceed?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
        }
      });
  };

  sendToBackend = () => {
    let obj = {
      userGroupId: 0,
      corporateId: this.state.corporateId,
      groupName: this.state.group_name,
      groupDesc: this.state.group_desc,
      users : [],
      status: 1,
    };
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios.post(apiConfig.UPDATE_CORPORATE_USER_GROUP,obj,{headers:headers}).then(r =>{
      if(r.status === 200) {
        if(r.data.success) {
          this.props.setUserGroupHandler(r.data.userGroupDetail);
          common.warningAlert(this.state.group_name + " user group had created successfully!", 0);
          this.props.spinnerHandler(false);
          this.props.closeModal();
        }
      }
    }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.sendToBackend();
      }
    }).finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  toggle = () => {};

  render() {
    let {
      corporateId,
      corporate_name,
      group_name,
      group_desc
    } = this.state;

    let btn_disable = false;

    if(group_name ==="" || group_desc === "" ) {
      btn_disable = true;
    } else {
      btn_disable = false;
    }

    return(
      <div>
        <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="md">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>Create New User Group</MDBModalHeader>
          <MDBModalBody>
            <div className={'update-form'}>
              <Form>
                <Form.Field>
                  <label>Corporate</label>
                  <input placeholder='Corporate Name' value={corporate_name} disabled={true} />
                </Form.Field>
                <Form.Field>
                  <label>User Group Name</label>
                  <input placeholder='User Group Name' value={group_name} onChange={  this.onChangeUserGroupName} />
                </Form.Field>
                <Form.Field>
                  <Form.TextArea label='User Group Description' value={group_desc} onChange={ this.onChangeUserGroupDesc } placeholder='Tell us more about you...' />
                </Form.Field>
                <Form.Field className={'text-right'}>
                  <Button className="px-5" onClick={ this.createUserGroup } disabled={btn_disable}>Create</Button>
                </Form.Field>
              </Form>
            </div>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserGroupHandler: (data) => dispatch(actionCreator.saveUserGroupDetails(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserGroupModal);
